import clsx from 'clsx'

export const FormButton = ({ children, className }: React.PropsWithChildren<any>) => {
  return <div className={clsx('text-center mt-10 md:mt-[60px]', className)}>{children}</div>
}
